<template>
    <v-switch v-model="aceptadaLocal" color="secondary" class="primary--text" :rules="[obligatoria]"
              :label="$t('acepto_politica')" :hint="$t(esMovil ? 'hint_movil' : 'hint_web')"
              persistent-hint/>
</template>

<script>
    export default {
        name: 'PoliticaPrivacidadComponent',
        components: {},
        model: {
            prop: 'aceptada',
            event: 'change'
        },
        props: {
            aceptada: {type: Boolean, required: true},
        },
        data: () => ({
            aceptadaLocal: false
        }),
        computed: {
            esMovil() {
                return this.$vuetify.breakpoint.smAndDown;
            }
        },
        watch: {
            aceptada(val) {
                this.aceptadaLocal = val;
            },
            aceptadaLocal(val) {
                this.$emit("change", val);
            }
        },
        methods: {
            obligatoria(value) {
                return !!value || this.$t('obligatoria')
            }
        }
    };
</script>

<!-- @formatter:off -->
<i18n>
{
"es": {
"acepto_politica": "Acepto la política de protección de datos",
"obligatoria": "Es obligatorio aceptar la política de protección de datos",
"hint_web": "Puedes leer la política de privacidad desde el enlace en el menú inferior",
"hint_movil": "Puedes leer la política de privacidad desde el enlace en el menú lateral"
}
}
</i18n>
<!-- @formatter:on -->